/*
 * Event Service.
 */

/**
 * REST CLIENT PER WS DI GESTIONE DEL SITUATION RECORD
 */
'use strict';
module.exports = [
  '$rootScope',
  '$resource',
  '$httpParamSerializerJQLike',
  function ($rootScope, $resource, $httpParamSerializerJQLike) {
    var mainConfig = global.ngDroAstralSituationRecordMainConfig;
    var validityPeriodEndDateNullValue = moment.utc(
      mainConfig.ValidityPeriodEndDateNullValue,
      'YYYY-MM-DD  HH:mm:ss'
    );

    var baseEndPointUrl = mainConfig.ApiUrl;
    var baseEndPointPublicUrl = mainConfig.PublicApiUrl;
    var situationRecordEndPointUrl = baseEndPointUrl + 'situation-record/';
    return $resource(
      baseEndPointUrl,
      {},
      {
        create: {
          method: 'POST',
          url: situationRecordEndPointUrl,
          withCredentials: true,
          transformRequest: function (data) {
            data.isTemplate = false;
            var json = angular.toJson(data);
            return json;
          },
        },
        update: {
          method: 'PUT',
          url: situationRecordEndPointUrl,
          withCredentials: true,
          transformRequest: function (data) {
            data.isTemplate = false;
            var json = angular.toJson(data);
            return json;
          },
        },
        getAll: {
          method: 'GET',
          url: situationRecordEndPointUrl,
          withCredentials: true,
          isArray: true,
          params: {
            page: '@page',
            size: '@size',
            sort: '@sort',
          },
          transformResponse: function (data) {
            var response = angular.fromJson(data);
            if (response.content) {
              angular.forEach(response.content, function (sr) {
                if (sr.validityPeriods && sr.validityPeriods != null) {
                  angular.forEach(sr.validityPeriods, function (period) {
                    var dateEnd = moment.utc(period.dateEnd, 'YYYY-MM-DD  HH:mm:ss');
                    if (moment(dateEnd).isSame(validityPeriodEndDateNullValue)) {
                      period.dateEnd = null;
                    }
                  });
                }
              });
            }
            return response;
          },
        },
        get: {
          method: 'GET',
          url: situationRecordEndPointUrl + ':id',
          withCredentials: true,
          params: {
            id: '@id',
          },
          transformResponse: function (data) {
            var response = angular.fromJson(data);
            if (response.validityPeriods && response.validityPeriods != null) {
              angular.forEach(response.validityPeriods, function (period) {
                var dateEnd = moment.utc(period.dateEnd, 'YYYY-MM-DD  HH:mm:ss');
                if (moment(dateEnd).isSame(validityPeriodEndDateNullValue)) {
                  period.dateEnd = null;
                }
              });
            }
            return response;
          },
        },
        delete: {
          method: 'DELETE',
          url: situationRecordEndPointUrl + ':id',
          withCredentials: true,
          params: {
            id: '@id',
          },
        },
        search: {
          method: 'POST',
          url: situationRecordEndPointUrl + 'search',
          withCredentials: true,
          data: {
            clazz: 'com.dromedian.jdro.datex2.domain.SituationRecordFilterEntity',
            id: null,
            validityPeriodsDateStart: '@validityPeriodsDateStart',
            validityPeriodsDateEnd: '@validityPeriodsDateEnd',
            topLeft: '@topLeft',
            bottomRight: '@bottomRight',
            eventTypeList: '@eventTypeList',
            createdDateStart: '@createdDateStart',
            createdDateEnd: '@createdDateEnd',
            severity: '@severity',
            validityStatus: '@validityStatus',
            probabilityOfOccurrence: '@probabilityOfOccurrence',
            confidentiality: '@confidentiality',
            cause: '@cause',
            sourceList: '@sourceList',
            comment: '@comment',
            publicSiteEvidence: '@publicSiteEvidence',
          },
          params: {
            page: '@page',
            size: '@size',
            sort: '@sort',
          },
          transformResponse: function (data) {
            var response = angular.fromJson(data);
            if (response.content) {
              angular.forEach(response.content, function (sr) {
                if (sr.validityPeriods && sr.validityPeriods != null) {
                  angular.forEach(sr.validityPeriods, function (period) {
                    var dateEnd = moment.utc(period.dateEnd, 'YYYY-MM-DD  HH:mm:ss');

                    if (moment(dateEnd).isSame(validityPeriodEndDateNullValue)) {
                      period.dateEnd = null;
                    }
                  });
                }
              });
            }
            return response;
          },
        },
        situationRecordGetTypes: {
          method: 'GET',
          url: situationRecordEndPointUrl + 'get-types',
          withCredentials: true,
        },
        uploadAttachment: {
          method: 'POST',
          url: situationRecordEndPointUrl + ':id/attachment/upload',
          withCredentials: true,
          params: {
            id: '@id',
          },
          transformRequest: function (data) {
            var fd = new FormData();
            fd.append('file', data.file);
            return fd;
          },
          headers: {
            'Content-Type': undefined,
            //, enctype: 'multipart/form-data'
          },
        },
        deleteAttachment: {
          method: 'DELETE',
          url: situationRecordEndPointUrl + ':id/attachment/delete/:attachmentId',
          withCredentials: true,
          params: {
            id: '@id',
            attachmentId: '@attachmentId',
          },
        },
        downloadAttachment: {
          method: 'GET',
          //url: situationRecordEndPointUrl + ':id/attachment/download/:attachmentId',
          url: baseEndPointPublicUrl + 'situation-record/:id/attachment/download/:attachmentId',
          withCredentials: true,
          params: {
            id: '@id',
            attachmentId: '@attachmentId',
          },
          transformResponse: function (data, headers) {
            var ret = {
              data: data,
              headers: headers,
            };
            return ret;
          },
        },
        getAttachmentList: {
          method: 'GET',
          url: situationRecordEndPointUrl + ':id/get-attachments',
          withCredentials: true,
          isArray: true,
          params: {
            id: '@id',
          },
        },
        duplicate: {
          method: 'GET',
          url: situationRecordEndPointUrl + 'duplicate/:id',
          withCredentials: true,
          params: {
            id: '@id',
          },
        },
        endValidity: {
          method: 'GET',
          url: situationRecordEndPointUrl + 'end-validity/:id',
          withCredentials: true,
          params: {
            id: '@id',
          },
        },
        broadcast: {
          method: 'POST',
          isArray: true,
          url: situationRecordEndPointUrl + 'send-push-notifications/:id',
          withCredentials: true,
          params: {
            id: '@id',
          },
        },
      }
    );
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/services/situationRecordServiceCtrl.js
// module id = 253
// module chunks = 0